
import Card from '../base/Card';

export default function HowWeWork() {
  const pillars = [
    {
      icon: 'ri-lock-line',
      title: 'Confidencialidade Total',
      description: 'Todas as investigações são conduzidas com absoluta discrição e sigilo profissional, protegendo a reputação da sua empresa.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Documentação Legal',
      description: 'Relatórios detalhados e evidências admissíveis em processos legais, seguindo todos os protocolos jurídicos necessários.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Imparcialidade Profissional',
      description: 'Investigações conduzidas sem viés, baseadas exclusivamente em fatos e evidências concretas para decisões assertivas.'
    },
    {
      icon: 'ri-time-line',
      title: 'Agilidade e Eficiência',
      description: 'Prazos definidos e cumpridos, com relatórios de progresso regulares para manter você informado sobre o andamento.'
    }
  ];

  return (
    <section id="como-trabalhamos" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Como Trabalhamos
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nossa metodologia é baseada em quatro pilares fundamentais que garantem 
            resultados confiáveis e admissíveis legalmente.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.map((pillar, index) => (
            <Card key={index} className="text-center h-full" padding="lg">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${pillar.icon} text-3xl text-gray-900`}></i>
              </div>
              
              <h4 className="text-lg font-semibold text-gray-900 mb-4">
                {pillar.title}
              </h4>
              
              <p className="text-gray-600 text-sm leading-relaxed">
                {pillar.description}
              </p>
            </Card>
          ))}
        </div>

        <div className="mt-16 bg-gray-50 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">
                Processo de Investigação
              </h4>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm font-bold mr-4 flex-shrink-0">
                    1
                  </div>
                  <div>
                    <strong className="text-gray-900">Análise Inicial:</strong>
                    <span className="text-gray-600 ml-1">Avaliação detalhada do caso e definição de estratégia</span>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm font-bold mr-4 flex-shrink-0">
                    2
                  </div>
                  <div>
                    <strong className="text-gray-900">Investigação:</strong>
                    <span className="text-gray-600 ml-1">Coleta de evidências seguindo protocolos legais</span>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm font-bold mr-4 flex-shrink-0">
                    3
                  </div>
                  <div>
                    <strong className="text-gray-900">Documentação:</strong>
                    <span className="text-gray-600 ml-1">Relatório completo com evidências admissíveis</span>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm font-bold mr-4 flex-shrink-0">
                    4
                  </div>
                  <div>
                    <strong className="text-gray-900">Apresentação:</strong>
                    <span className="text-gray-600 ml-1">Entrega dos resultados e orientações legais</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="lg:pl-8">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20investigator%20presenting%20case%20results%20to%20business%20executives%20in%20modern%20conference%20room%2C%20legal%20documents%20on%20table%2C%20professional%20presentation%2C%20corporate%20meeting%2C%20investigation%20report%2C%20business%20consultation%2C%20professional%20atmosphere&width=600&height=400&seq=investigation-process&orientation=landscape"
                alt="Processo de Investigação"
                className="w-full h-64 object-cover object-top rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
